import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import RoomTag from '@app/site/secured/rateshopper/rates/settings/page/room-mapping/fragment/RoomTag';
import HotelRoomWithMapping from '@app/model/company_hotel_room_mappings_type_configuration/HotelRoomWithMapping';

const DraggableRoomTag: React.FunctionComponent<{ hotelId: number, roomMapping: HotelRoomWithMapping }> = ({
																																																						 hotelId,
																																																						 roomMapping,
																																																					 }) => {
	const {
		attributes, listeners,
		setNodeRef,
		transform,
		isDragging,
	} = useDraggable({
		id: roomMapping.roomId,
		data: { hotelId: hotelId, roomMapping: roomMapping },
	});

	const opacity = isDragging ? 0 : 1;

	const style = {
		transform: CSS.Transform.toString(transform),
		opacity,
	};

	return <div ref={setNodeRef}  style={style}
							className="mt-2 inline-flex rounded-md shadow-sm mr-2">
		<RoomTag roomMapping={roomMapping} listeners={listeners} attributes={attributes}/>
	</div>;
};

export default DraggableRoomTag;